import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-orange-500/20" data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-219">
          {/* Logo */}
          <a href="https://www.instagram.com/pirmaisracing_/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 group" data-id="element-220">
            <img src="https://cdn.magicpatterns.com/uploads/bXrefJ2oBh4YLN5nxqUgzp/PHOTO-2024-12-29-00-15-52.jpg" alt="Motomaniac Logo" className="h-12 w-auto object-contain rounded-lg border border-orange-500/20" data-id="element-221" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-222">
            <a href="#classes" className="text-sm font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-223">
              {t('nav.classes')}
            </a>
            <a href="#map" className="text-sm font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-224">
              {t('nav.map')}
            </a>
            <a href="#info" className="text-sm font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-225">
              {t('nav.raceInfo')}
            </a>
            <a href="#team" className="text-sm font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-226">
              {t('nav.team')}
            </a>
            <a href="#gallery" className="text-sm font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-227">
              {t('nav.gallery')}
            </a>

            {/* Language Switcher */}
            <div className="flex items-center rounded-full overflow-hidden border border-neutral-700" data-id="element-228">
              <button onClick={() => setLanguage('lv')} className={`px-3 py-1.5 text-xs font-bold uppercase transition-colors ${language === 'lv' ? 'bg-orange-500 text-black' : 'bg-neutral-800 text-gray-400 hover:text-white'}`} aria-label="Latvian" data-id="element-229">
                LV
              </button>
              <button onClick={() => setLanguage('en')} className={`px-3 py-1.5 text-xs font-bold uppercase transition-colors ${language === 'en' ? 'bg-orange-500 text-black' : 'bg-neutral-800 text-gray-400 hover:text-white'}`} aria-label="English" data-id="element-230">
                EN
              </button>
            </div>

            <a href="#contact" className="px-6 py-2.5 bg-orange-500 hover:bg-orange-600 text-black font-bold text-sm uppercase tracking-wider rounded transition-colors" data-id="element-231">
              {t('nav.register')}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-gray-300 hover:text-white" aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen} data-id="element-232">
            {isOpen ? <XIcon className="h-6 w-6" data-id="element-233" /> : <MenuIcon className="h-6 w-6" data-id="element-234" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-orange-500/20" data-id="element-235">
          <div className="px-4 py-6 space-y-4" data-id="element-236">
            {/* Language Switcher - Mobile */}
            <div className="flex items-center justify-center mb-4" data-id="element-237">
              <div className="flex items-center rounded-full overflow-hidden border border-neutral-700" data-id="element-238">
                <button onClick={() => setLanguage('lv')} className={`px-4 py-2 text-sm font-bold uppercase transition-colors ${language === 'lv' ? 'bg-orange-500 text-black' : 'bg-neutral-800 text-gray-400 hover:text-white'}`} aria-label="Latvian" data-id="element-239">
                  LV
                </button>
                <button onClick={() => setLanguage('en')} className={`px-4 py-2 text-sm font-bold uppercase transition-colors ${language === 'en' ? 'bg-orange-500 text-black' : 'bg-neutral-800 text-gray-400 hover:text-white'}`} aria-label="English" data-id="element-240">
                  EN
                </button>
              </div>
            </div>

            <a href="#classes" onClick={() => setIsOpen(false)} className="block text-lg font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-241">
              {t('nav.classes')}
            </a>
            <a href="#map" onClick={() => setIsOpen(false)} className="block text-lg font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-242">
              {t('nav.map')}
            </a>
            <a href="#info" onClick={() => setIsOpen(false)} className="block text-lg font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-243">
              {t('nav.raceInfo')}
            </a>
            <a href="#team" onClick={() => setIsOpen(false)} className="block text-lg font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-244">
              {t('nav.team')}
            </a>
            <a href="#gallery" onClick={() => setIsOpen(false)} className="block text-lg font-semibold text-gray-300 hover:text-orange-500 transition-colors uppercase tracking-wider" data-id="element-245">
              {t('nav.gallery')}
            </a>
            <a href="#contact" onClick={() => setIsOpen(false)} className="block text-center px-6 py-3 bg-orange-500 hover:bg-orange-600 text-black font-bold text-lg uppercase tracking-wider rounded transition-colors" data-id="element-246">
              {t('nav.register')}
            </a>
          </div>
        </div>}
    </nav>;
}